var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_vm._t("default"),(_vm.date)?_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.measuredTitle)+" "+_vm._s(_vm.date)+" ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }